import axios from '@/api/axios'

export default {
  resetPassword(user) {
    return axios.post(`/reset-password/phone`, user)
  },
  sendSmsCode(data) {
    return axios
      .post('/reset-password/sendSmsCode', data)
      .then((response) => response.data)
  },

  checkSmsCode(data) {
    return axios
      .post('/reset-password/checkSmsCode', data)
      .then((response) => response.data)
  },
  changePassword(stateAndPassword) {
    return axios.post(`/reset-password/changePassword`, stateAndPassword)
  },
}
